"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createTranslator = void 0;

var _trans2 = _interopRequireDefault(require("./trans"));

var _transChoice2 = _interopRequireDefault(require("./transChoice"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const createTranslator = () => {
  let translations = {};

  const addKeys = terms => {
    translations = { ...translations,
      ...terms
    };
  };

  const trans = (key, replace) => {
    return (0, _trans2.default)(translations, key, replace);
  };

  const transChoice = (key, count, replace) => {
    return (0, _transChoice2.default)(translations, key, count, replace);
  };

  return {
    addKeys,
    trans,
    transChoice
  };
};

exports.createTranslator = createTranslator;